import React, { useState } from 'react';
import DevLauncher from './DevLauncher';
import Styles from './DevLauncher.module.scss';

// 우측 상단 floating 버튼 — 클릭 시 DevLauncher 모달 토글.
// EntryRouter 가 target 없는 /init 진입 시 InitView 위에 mount.
const DevLauncherButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={Styles.FabButton}
        onClick={() => setIsOpen(true)}
        aria-label="개발자 진입 콘솔 열기"
      >
        <span className={Styles.FabDot} />
        DEV
      </button>
      {isOpen && <DevLauncher onClose={() => setIsOpen(false)} />}
    </>
  );
};

export default DevLauncherButton;
